import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

/**
 * Action that gets dispatched when search session should be exited.
 *
 * @param actionSource Where the action originates from
 * @param scenarioId Which search scenario dispatched the action
 * @param forceExit Indicates that search session should exit, regardless of the
 * scenario. In v1 of the search box UX, the exitSearch action has a different
 * outcome if the user is in SLV.
 */
const exitSearch = action(
    'EXIT_SEARCH_NEXT',
    (actionSource: string, scenarioId: SearchScenarioId, forceExit: boolean = false) => ({
        actionSource,
        scenarioId,
        forceExit,
    })
);

export default exitSearch;
